module.exports = __webpack_public_path__ + "static/img/right4.f4c82ea8.png";